var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.66699C5.40866 1.66699 1.66699 5.40866 1.66699 10.0003C1.66699 14.592 5.40866 18.3337 10.0003 18.3337C14.592 18.3337 18.3337 14.592 18.3337 10.0003C18.3337 5.40866 14.592 1.66699 10.0003 1.66699ZM13.6253 12.9753C13.5087 13.1753 13.3003 13.2837 13.0837 13.2837C12.9753 13.2837 12.867 13.2587 12.767 13.192L10.1837 11.6503C9.54199 11.267 9.06699 10.4253 9.06699 9.68366V6.26699C9.06699 5.92533 9.35033 5.64199 9.69199 5.64199C10.0337 5.64199 10.317 5.92533 10.317 6.26699V9.68366C10.317 9.98366 10.567 10.4253 10.8253 10.5753L13.4087 12.117C13.7087 12.292 13.8087 12.6753 13.6253 12.9753Z",
    fill: "url(#paint0_linear_97_5636)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_97_5636",
    x1: 10.0003,
    y1: 1.66699,
    x2: 10.0003,
    y2: 18.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(from var(--primary-color) h s l)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "hsl(from var(--primary-color) h s l)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.aceccc320ddfe65260a62a89ca94125b.svg";
export { ForwardRef as ReactComponent };